module.exports = "/_next/static/images/intercontinental-c46612438d68e31ed189eab1cfbe9665.png";